import { isMobile } from "react-device-detect";
import { Button } from "antd";
import React from "react";

const PanelButtonPlaceholder = () => <Button style={{ visibility: "hidden", minWidth: isMobile ? 55 : 40 }} />;

export default PanelButtonPlaceholder;
